<template>
	<div class="profile-manager">
		<div class="flex justify-end">
			<div v-if="isHomePage" class="alert-dark-blue">
				<div class="h1">
					{{ $tc('components.profileManager.helloMessageText') }} {{ userName }}!
				</div>
				<div class="mt-10">
					<p v-if="permissions.isClubAccount">
						{{ $tc('components.profileManager.clubTypeText[0]') }} <br> {{
							$tc('components.profileManager.clubTypeText[1]') }}
					</p>
					<p v-else-if="activePlan">
						{{ $tc('components.profileManager.activePlanText') }}
					</p>
					<p v-else>
						{{ $tc('components.profileManager.noActivePlanText') }}
					</p>
				</div>

				<div class="alert-actions font-uppercase">
					<template v-if="activePlan">
						<a :href="consultationLink" class="button-pink small font-bold" target="_blank">
							{{ $tc('components.profileManager.scheduleText') }}
						</a>
					</template>
					<template v-else>
						<a :href="consultationLink" class="button-pink small font-bold mr-20" target="_blank">
							{{ $tc('components.profileManager.scheduleDemoText') }}
						</a>

						<a class="button-light-blue small font-bold" href="#" @click.prevent="scrollToPlans">
							{{ $tc('components.profileManager.selectPlan') }}
						</a>
					</template>
				</div>
			</div>

			<div class="no-shrink pl-25 pb-35 bellow-laptop-hidden">
				<ProfilePartial />
			</div>
		</div>
	</div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { ProfilePartial } from '~/components/particles/index'
import analytics from '~/assets/util/analytics'

export default {
	name: 'ProfileManager',
	components: { ProfilePartial },
	computed: {
		...mapGetters({
			user: 'user/user',
			permissions: 'user/permissions',
			activePlan: 'plans/active',
			consultationLink: 'user/consultationLink',
			scheduleVSTrainingLink: 'user/scheduleVSTrainingLink'
		}),

		userName () {
			return this.user && this.user.name
		},

		isHomePage () {
			return this.$route.name === 'profile-my-pixellot'
		}
	},
	methods: {
		...mapActions({ analyticsTrack: 'analytics/track' }),
		trackVidSwapTrainingClick () {
			this.analyticsTrack({
				event: analytics.VidSwapUpsellTriggerClicked.event,
				data: analytics.VidSwapUpsellTriggerClicked.getData({
					trigger: 'SCHEDULE A VIDSWAP TRAINING',
					source: 'profile_manager'
				})
			})
		},
		scrollToPlans () {
			const plansEl = document.querySelector('#plan-selection')

			plansEl && plansEl.scrollIntoView({ behavior: 'smooth' })
		}
	}
}
</script>
